import { render } from "./BienImmo.vue?vue&type=template&id=3138b8e7"
import script from "./BienImmo.ts?vue&type=script&lang=js"
export * from "./BienImmo.ts?vue&type=script&lang=js"

import "./BienImmo.vue?vue&type=style&index=0&id=3138b8e7&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__